import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { Gateway } from 'react-gateway';
import classnames from 'classnames';

const Title = ({ children, className }) => {
  if (isEmpty(children)) return null;
  return (
    <Gateway into="title">
      <h2 className={classnames('c-title qa-title', className)}>
        { children }
      </h2>
    </Gateway>
  );
};
Title.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
Title.defaultProps = {
  className: '',
};

export default Title;



// WEBPACK FOOTER //
// ./src/app/components/Title.jsx